import React, { useState } from "react";
import MyProfile from "./MyProfile";
import Sidebar from "./SideBarMenu";
import Logout from "./Logout";
import AddPainting from "./AddPaintings";
import MyPaintings from "./MyPaintings";
import MyOrders from "./MyOrders";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("orders");

  const renderContent = () => {
    switch (activeTab) {
      case "add-painting":
        return <AddPainting />;
      case "my-paintings":
        return <MyPaintings />;
      case "orders":
        return <MyOrders />;
      case "profile":
        return <MyProfile />;
      case "logout":
        return <Logout />;
      default:
        return <MyOrders />;
    }
  };

  return (
    <div style={styles.container}>
      <Sidebar setActiveTab={setActiveTab} />
      <div style={styles.content}>{renderContent()}</div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    // height: "100vh",
    marginTop: "70px",
  },
  content: {
    flex: 1,
    padding: "20px",
  },
};

export default AdminDashboard;
